import { useState } from "react";

import {
  Box,
  HStack,
  Pressable,
  Text,
} from "@whoosh/design-system/src/components/primitive";

type RewardsNavigationButtonProps = {
  label: string;
  count?: number;
  accessibilityLabel: string;
  testID: string;
  onPress: () => void;
};

export const RewardsNavigationButton = ({
  label,
  count,
  accessibilityLabel,
  testID,
  onPress,
}: RewardsNavigationButtonProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isPressed, setIsPressed] = useState(false);
  const isHighlighted = isHovered || isPressed;

  return (
    <Pressable
      accessibilityLabel={accessibilityLabel}
      accessibilityRole="button"
      testID={testID}
      onPress={onPress}
      onHoverIn={() => setIsHovered(true)}
      onHoverOut={() => setIsHovered(false)}
      onPressIn={() => setIsPressed(true)}
      onPressOut={() => setIsPressed(false)}
      borderColor="surface-accent-purple-subtle"
      borderRadius="2"
      borderWidth={1}
      backgroundColor="surface-primary"
      padding={4}
      width="100%"
      _hover={{ backgroundColor: "surface-accent-purple-subtler" }}
      _pressed={{ backgroundColor: "surface-accent-purple-subtler" }}
    >
      <HStack alignItems="center" justifyContent="space-between" gap={3}>
        <Text variant="mainBaseSemiBold" color="text-accent-purple-primary">
          {label}
        </Text>
        {count !== undefined ? (
          <Box
            width={18}
            height={18}
            borderRadius="6"
            backgroundColor={
              isHighlighted
                ? "surface-primary"
                : "surface-accent-purple-subtler"
            }
            alignItems="center"
            justifyContent="center"
          >
            <Text variant="mainTiny" color="text-accent-purple-primary">
              {count}
            </Text>
          </Box>
        ) : null}
      </HStack>
    </Pressable>
  );
};
